<template>
    <div>
        <headline-container headline="Edit Tag" :breadcrumbs="breadcrumbs">
            <button type="button" class="btn btn-white pull-right" @click="destroy">
                <i class="fa fa-trash"></i> Delete
            </button>
        </headline-container>

        <loading-container v-if="loading"></loading-container>

        <div v-else class="container">
            <div class="row">
                <div class="col-xs-6">
                    <help-text>
                        <h3>
                            Edit Tag
                        </h3>

                        <p>
                            Enter the details of the tag.
                        </p>
                    </help-text>
                </div>

                <div class="col-xs-18">
                    <div class="panel panel-default">
                        <div class="panel-body">
                            <form @submit.prevent="submit" class="form-horizontal">
                                <text-form-group
                                    v-model="data.name"
                                    name="name"
                                    label="Name"
                                    help-text="The name of the tag."
                                    :error="getError('name')"
                                ></text-form-group>

                                <color-form-group
                                    v-model="data.color"
                                    name="color"
                                    label="Color"
                                    help-text="The color of the tag."
                                    :colors="colors"
                                    :error="getError('color')"
                                ></color-form-group>

                                <hr>

                                <submit-form-group button-class="btn-black"></submit-form-group>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import notify from '@/notify'
import ColorFormGroup from '@/components/FormGroups/Horizontal/Color'
import Errors from '@/mixins/Errors'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import HelpText from '@/components/HelpText'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

export default {
    components: {
        ColorFormGroup,
        HeadlineContainer,
        HelpText,
        LoadingContainer,
        SubmitFormGroup,
        TextFormGroup
    },

    mixins: [Errors],

    props: ['id'],

    data() {
        return {
            tag: null,
            colors: [],

            data: {},

            loading: true
        }
    },

    mounted() {
        Promise.all([
            http.get('/api/v2/tags/' + this.id),
            http.get('/api/v2/colors')
        ]).then(responses => {
            this.tag = responses[0].data.data

            this.colors = responses[1].data.data

            this.data = {...this.tag.attributes}

            this.loading = false
        })
    },

    computed: {
        breadcrumbs() {
            return [
                {url: '/tags', text: 'Tags'},
                {text: 'Edit'}
            ]
        }
    },

    methods: {
        submit() {
            http.put('/api/v2/tags/' + this.tag.id, this.data)
                .then(() => {
                    notify.success('The tag was saved')

                    this.$router.push('/tags')
                })
                .catch(this.catchValidationErrors)
        },

        destroy() {
            modal.confirm('Are you sure that you want to delete the tag?', () => {
                http.delete('/api/v2/tags/' + this.tag.id)
                    .then(() => {
                        notify.success('The tag was deleted')

                        this.$router.push('/tags')
                    })
            })
        }
    }
}
</script>
